import React from 'react';
import { CheckCircle, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ApplicationDocumentReview: React.FC = () => {
    const navigate = useNavigate();

    const handleContactClick = () => {
        navigate('/eligibility?service=immigration');
    };

    return (
        <div className="bg-white min-h-screen pt-32 pb-20">
            <div className="bg-[#009B8F] text-white py-16 mb-16">
                <div className="max-w-7xl mx-auto px-6">
                    <h1 className="text-4xl md:text-5xl font-serif mb-4">Application Document Review</h1>
                    <p className="text-xl text-white/90 max-w-2xl">
                        Timely review, personalized advice, and direct coordination with universities.
                    </p>
                </div>
            </div>

            <div className="max-w-5xl mx-auto px-6">
                <div className="flex items-center gap-4 mb-8">
                    <div className="p-3 bg-[#009B8F]/10 rounded-full">
                        <FileText className="text-[#009B8F] w-8 h-8" />
                    </div>
                    <h2 className="text-3xl font-serif text-[#011E26]">Accurate, Updated & On Time</h2>
                </div>

                <div className="prose prose-lg text-slate-600 max-w-none">
                    <p className="mb-4">
                        Our Application Document Review service ensures that every student's application is accurately prepared, updated, and submitted on time. At NexOverseas, we understand that maintaining proper timelines and consistent communication is just as important as having the correct documentation.
                    </p>
                    <p className="mb-4">
                        With this service, we monitor the status of each application carefully and provide timely updates and advice to students. Our team reviews all submitted documents to ensure they meet university requirements and compliance standards. In addition, we liaise directly with universities when needed, addressing queries and ensuring smooth coordination throughout the process.
                    </p>

                    <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#009B8F] mb-8">
                        <h3 className="text-lg font-bold text-[#011E26] mb-3 uppercase tracking-wide">Students benefit from:</h3>
                        <ul className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            {[
                                "Timely review of all application materials, minimizing errors or delays",
                                "Personalized advice and reminders to keep their application on track",
                                "Direct coordination with universities to ensure smooth processing of applications",
                                "Structured updates on progress, deadlines, or additional requirements"
                            ].map((item, i) => (
                                <li key={i} className="flex items-start gap-2 text-sm font-medium">
                                    <CheckCircle className="w-5 h-5 text-[#009B8F] flex-shrink-0" />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <p className="mb-6">
                        By offering proactive monitoring and guidance, NexOverseas ensures that students are never left unsure about the status of their applications. This service is designed to provide peace of mind, streamline communication, and maximize the efficiency and accuracy of every submission.
                    </p>

                    <button
                        onClick={handleContactClick}
                        className="bg-[#009B8F] text-white px-8 py-3 font-bold uppercase tracking-widest hover:bg-[#00857a] transition-colors rounded-sm shadow-lg"
                    >
                        Get in Touch Today
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ApplicationDocumentReview;
